import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { Typography } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import { Box } from "@mui/system";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { v4 as uuidv4 } from 'uuid';
import { fileUploadServiceNew } from "../../services/fileUpload/FileUpload";
import FileViewFromBlobUrl from "../MobileComponents/MobileCommon/FileView";
import { triggerAppAlert } from './../../redux/actions/SelfServicePortal/ContactAid/ContactAid';

function base64ToBlob(base64: any, contentType = '', sliceSize = 512) {
  // Check if the base64 string has a data URL prefix
  if (base64.includes(',')) {
      // Split the base64 string to remove the prefix
      base64 = base64.split(',')[1];
  }

  const byteCharacters = atob(base64);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);

      for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, { type: contentType });
}


export function getFileNameAndExtension(url: string) {
  try {
    // Extract file name from URL
    const filenameRegex = /\/([^\/?#]+)$/;
    const filenameMatches = filenameRegex.exec(url);
    let filename = filenameMatches ? filenameMatches[1] : null;

    // Strip UUID prefix from filename (format: xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx-originalname.ext)
    // UUID regex: 8 chars - 4 chars - 4 chars - 4 chars - 12 chars followed by dash
    if (filename) {
      const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}-(.+)$/i;
      const match = uuidRegex.exec(filename);
      if (match) {
        filename = match[1]; // Extract original filename without UUID prefix
      }
    }

    // Extract file extension from URL
    const extensionRegex = /\.([0-9a-z]+)(?:[\?#]|$)/i;
    const extensionMatches = extensionRegex.exec(url);
    const fileExtension = extensionMatches ? extensionMatches[1] : null;

    // Determine MIME type based on file extension
    let type = "unknown";
    if (fileExtension) {
      switch (fileExtension.toLowerCase()) {
        case "png":
        case "jpg":
        case "jpeg":
        case "bmp":
          type = "image";
          break;
        case "pdf":
          type = "pdf";
          break;
        case "doc":
        case "docx":
          type = "doc";
          break;
        case "xls":
        case "xlsx":
          type = "excel";
          break;
        case "zip":
          type = "archive";
          break;
        case "txt":
          type = "text";
          break;
        case "mp4":
          type = "video";
          break;
      }
    }

    return { filename, fileExtension, type };
  } catch (error) {
    console.error("Error:", error);
    return { filename: null, fileExtension: null, type: "unknown" };
  }
}

const useStyles = makeStyles(() =>
  createStyles({
    attachmentBox: {
      border: "1px solid #ddd",
      display: "flex",
      flexDirection: "row",
      gap: 10,
      padding: 10,
      alignItems: "center",
      "& img": {
        height: "30px",
      },
      "& p": {
        fontSize: 10,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: 70,
      },
      "& .del-icon": {
        "& svg": {
          height: "20px !important",
          width: "20px !important",
          color: "#ff0000",
        }
      }
    },
  })
);

const addAttchmentUsingFileAPI = async (fileObject: any) => {
//   console.log("addAttchmentfileObject", fileObject);
  let res: any = await fileUploadServiceNew(fileObject);
  return res;
};


const AddAttachmentBlobWithPreview = (props: any) => {
  
  const dispatch = useDispatch();
  const [fName,setfName] = useState<string[]>([])
  const classes = useStyles();

  const imgCallBack = async (files: any) => {
//     console.log("AddAttachmentBlobWithPreview", files, files.length > 0);
    if (files.length > 0) {
      const filesArray = Array.from(files);

      if (props.isAttachmentOnFly) {
        // Upload multiple files and wait for all to complete
        const uploadPromises = filesArray.map((file: any) => {
//           console.log("imgCallBack files", file);
          const fileName = `${uuidv4()}-${file?.name}`;

          let fileObject = {
            name: fileName,
            fileTypeId: 1,
            ExtensionTypeId: 1,
            formFile: file,
            moduleType: "quicksendmailattachment",
          };
          setfName(prev => [...prev, file.name]);

          if(fName.includes(file.name)){
            setfName(prev => prev.slice(0, -1));
             dispatch(triggerAppAlert(`You’ve already uploaded this file : ${file.name}`, "warning"));
             return false
          }
          return addAttchmentUsingFileAPI(fileObject).then((res: any) => {
            if (res && res.data) {
//               console.log("addAttchmentUsingFileAPI res", res.data.filePath);
              return {
                attachmentPath: res.data.filePath,
                attachmentId: res.data.id,
                fileName: fileName,
                fileType: file?.type,
              };
            } else {
              console.error("File upload failed for:", file.name, res);
              alert(`Failed to upload file: ${file.name}. Please try again.`);
              return null;
            }
          }).catch((error: any) => {
            console.error("File upload error for:", file.name, error);
            alert(`Error uploading file: ${file.name}. ${error.message || 'Please try again.'}`);
            return null;
          });
         
        });

        // Wait for all uploads to complete
        const uploadedFiles = await Promise.all(uploadPromises);

        // Filter out any failed uploads and update state once
        const successfulUploads = uploadedFiles.filter(file => file !== null && file !== false  && file !== undefined);
        const failedCount = uploadedFiles.length - successfulUploads.length;
        
        if (successfulUploads.length > 0) {
          props.setAttachmentList([...props?.attachmentList, ...successfulUploads]);
        
        }

        if (failedCount > 0) {
          // alert(`${failedCount} file(s) failed to upload. Please check console for details.`);
        }
      } else {
        // Process files for preview (non-fly mode)
        const readPromises = filesArray.map((file: any) => {
          return new Promise((resolve) => {
            const reader = new FileReader();
            const fileName = `${uuidv4()}-${file?.name}`;

            reader.onloadend = () => {
              resolve({
                preview: reader.result,
                fileName: fileName,
                fileType: file?.type,
                formFile: file,
                type: props?.type
              });
            };
            reader.readAsDataURL(file);
          });
        });

        // Wait for all files to be read
        const readFiles = await Promise.all(readPromises);
        props.setAttachmentList([...props?.attachmentList, ...readFiles]);
      }
    }
  };

  const handleDelete = (index: any) => {
    setfName(prev => prev.filter((_, i) => i !== index));
    props.setAttachmentList(
      props.attachmentList.filter((_: any, i: any) => i !== index)
    );
  };

  return (
    <>
      {props.isShowBtn && (
        <Box>
          <>
            {" "}
            <input
              id={props.type}
              accept={props?.accept}
              type="file"
              multiple={true}
              onChange={(e: any) => {
                imgCallBack(e.target.files);
                e.target.value = "";
              }}
              //value={FileUploadVal}
              className="d-none"
            />
            <label
              className="Add-Attachment"
              htmlFor={props.type}
              style={{
                fontSize: "16px",
                cursor: "pointer",
                color: "#0A93FC",
                display: "inline-block",
                padding: "10px 0",
              }}
            >
              {props?.btnLabel}{" "}
              {"("}
              {props?.attachmentList?.length}
              {")"}
            </label>
          </>
        </Box>
      )}

      {props?.attachmentList?.length > 0 && (
        <div
          style={{
            marginLeft: "0px",
            display: "flex",
            flexDirection: "row",
            gap: 10,
            flexWrap: "wrap",
          }}
        >
          {props?.attachmentList?.map((i: any, index: number) => {
            return (
              <>
                <Box className="col-auto">
                  <Box
                    className={`${classes.attachmentBox}`}
                  >
                     <FileViewFromBlobUrl 
                      url={i?.preview || i?.attachmentPath}
                    />
                    
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <Typography variant="body2">
                        {i?.preview
                          ? i?.fileName?.length > 7
                            ? i?.fileName?.slice(0, 7)
                            : i?.fileName
                          : getFileNameAndExtension(i?.attachmentPath)
                              ?.filename}
                      </Typography>
                      <Typography style={{ color: "gray" }} variant="body2">
                        {i?.preview
                          ? i?.fileType
                          : getFileNameAndExtension(i?.attachmentPath)
                              ?.fileExtension}
                      </Typography>
                    </div>
                    <Box className="cursor-pointer del-icon">
                      <DeleteOutlinedIcon
                        className="cursor-pointer"
                        onClick={() => {
                          handleDelete(index);
                        }}
                      />
                    </Box>
                  </Box>
                </Box>
              </>
            );
          })}
        </div>
      )}
    </>
  );
};

export default AddAttachmentBlobWithPreview;
